import { criarEnv } from "./env.config";

// ----------------------------- Utilização do env validado em toda a aplicação
export const env = criarEnv(import.meta.env);
export type Env = typeof env;
